const medicalTypes = new Set(["diseases", "disease", "psychiatry and psychology"]);
const productTypes = new Set(["drug", "biologic", "device", "otc", "vaccine"]);

const texts = (value) => {
  const seen = new Set();
  return (Array.isArray(value) ? value : [value]).filter((item) => {
    if (typeof item !== "string" || !item.trim()) return false;
    const key = item.trim().normalize("NFKC").toLowerCase().replace(/\s+/g, " ");
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).map((item) => item.trim());
};
const text = (value) => texts(value).join(", ");
const firstAvailable = (...values) => values.map(text).find(Boolean) || "";

/** Display labels stay separate from the canonical values used for selection. */
export function getSearchSuggestionLabel(row, kind = "search") {
  if (kind === "history") return firstAvailable(row?.clickedProduct?.productName, row?.clickedProduct?.genericName);
  const type = String(row?.type || "").toLowerCase();
  if (medicalTypes.has(type)) return firstAvailable(row?.displayTerm, row?.term, row?.name);
  if (type === "manufacturer" || type === "pipeline") return firstAvailable(row?.name, row?.displayName);
  return firstAvailable(row?.openfda?.brand_name, row?.openfda?.generic_name, row?.name);
}

/** Keep dropdown context readable; source identifiers stay in selection data. */
export function getSearchSuggestionSubtitle(row, kind = "search") {
  const type = String(row?.type || "").toLowerCase();
  const history = kind === "history";
  const stored = history ? row?.clickedProduct : undefined;
  if (type === "pipeline") {
    const sponsors = texts(stored?.sponsor || row?.sponsor || row?.uniqueSponsors);
    return { text: sponsors.length ? `by ${sponsors.join(", ")}` : "", title: sponsors.join(", ") };
  }
  if (!productTypes.has(type)) return { text: "", title: "" };

  const details = (history ? stored?.displayDetails : row?.displayDetails) || {};
  const manufacturers = texts(details.manufacturers);
  const companies = manufacturers.length ? manufacturers : texts(stored?.productBrand || row?.openfda?.manufacturer_name);
  const family = history ? stored?.catalogDisplayFamily : row?.catalogDisplayFamily;
  const generic = firstAvailable(details.genericNames, history ? stored?.genericName : row?.openfda?.generic_name);
  const familyContext = Boolean(family) || (history && Boolean(generic) && Boolean(text(stored?.productName)));
  const company = familyContext && companies.length > 1
    ? `${companies[0]} +${companies.length - 1} more`
    : companies.join(", ");
  const context = familyContext ? generic : "";
  const contextTitle = context ? `Generic: ${context}` : "";
  const companyTitle = familyContext && companies.length ? `Companies: ${companies.join(", ")}` : company;
  return {
    text: [company, context].filter(Boolean).join(" · "),
    title: [companyTitle, contextTitle].filter(Boolean).join(" · "),
  };
}
